var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mw-page-sub-menu\">\n<div class=\"mw-page-sub-menu-title\">\n{{wizard.title}}\n</div>\n<ul class=\"mw-page-sub-menu-list\">\n<li ng-class=\"{active:$index === wizard.step_cur_index}\" ng-repeat=\"step in wizard.steps\">\n{{step}}\n</li>\n</ul>\n</div>\n";
var id1="app/shared/sub-menu.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;